// card-product-hover.js
// Handles hover functionality for product cards to show the second image

document.addEventListener('DOMContentLoaded', function () {
  // Initialize our components with a short delay
  setTimeout(() => {
    initCardProductHover();
    overrideCarouselNavigation();
  }, 300);
  
  // In case of dynamic section loads (Shopify)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(() => {
      initCardProductHover();
      overrideCarouselNavigation();
    }, 300);
  });
});

// Lazy load a specific image in a product card
function lazyLoadCardImage(card, imageIndex) {
  const mediaContainer = card.querySelector('.card__media .media');
  if (!mediaContainer) return false;
  
  const images = Array.from(mediaContainer.querySelectorAll('img'));
  if (imageIndex >= images.length) return false;
  
  const img = images[imageIndex];
  
  // Check if this image is already loaded
  if (img.hasAttribute('data-loaded')) return true;
  
  // Get data-src or srcset if available (assuming lazy loading attributes are used)
  const dataSrc = img.getAttribute('data-src');
  const dataSrcset = img.getAttribute('data-srcset');
  
  if (dataSrc && !img.src) {
    img.src = dataSrc;
  }
  
  if (dataSrcset && !img.srcset) {
    img.srcset = dataSrcset;
  }
  
  // Force load by setting loading attribute to eager
  img.setAttribute('loading', 'eager');
  
  // Mark as loaded
  img.setAttribute('data-loaded', 'true');
  
  return img.complete;
}

// Load next image when needed
function loadNextImage(card, nextIndex) {
  // Only load the specified index
  lazyLoadCardImage(card, nextIndex);
  
  const mediaContainer = card.querySelector('.card__media .media');
  if (!mediaContainer) return;
  
  const images = Array.from(mediaContainer.querySelectorAll('img'));
  
  // Setup the visibility of images
  images.forEach((img, idx) => {
    // Keep first image visible, set others to hidden initially
    if (idx === 0) {
      img.style.display = 'block';
      img.style.opacity = '1';
      img.style.visibility = 'visible';
    } else {
      img.style.opacity = '0';
      img.style.display = 'block';
      img.style.visibility = 'hidden'; // Hide until needed
    }
  });
}

// Override the carousel navigation to skip the second image when clicking "Next"
function overrideCarouselNavigation() {
  // Find all right arrow buttons and override their click handlers
  document.querySelectorAll('.card__arrow--right').forEach(rightArrow => {
    // Check if we've already modified this arrow
    if (rightArrow.hasAttribute('data-hover-modified')) return;
    
    // Mark as modified
    rightArrow.setAttribute('data-hover-modified', 'true');
    
    // Remove any existing listeners
    const clone = rightArrow.cloneNode(true);
    rightArrow.parentNode.replaceChild(clone, rightArrow);
    
    // Add our custom handler
    clone.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const card = this.closest('.product-card-wrapper');
      if (!card) return;
      
      const mediaContainer = card.querySelector('.card__media .media');
      if (!mediaContainer) return;
      
      const images = Array.from(mediaContainer.querySelectorAll('img'));
      if (images.length <= 2) return; // Need at least 3 images for this to work
      
      // Get current index
      let currentIndex = card.hasAttribute('data-carousel-current') 
        ? parseInt(card.getAttribute('data-carousel-current'), 10)
        : 0;
      
      // If we're at index 0 (first image), skip index 1 (second image) and go to index 2 (third image)
      if (currentIndex === 0) {
        currentIndex = 2; // Go directly to the third image
      } else {
        // For other indices, normal behavior (increment by 1)
        currentIndex = (currentIndex + 1) % images.length;
        
        // But skip index 1 (reserved for hover)
        if (currentIndex === 1) {
          currentIndex = (currentIndex + 1) % images.length;
        }
      }
      
      // Lazy load the next image we're moving to
      lazyLoadCardImage(card, currentIndex);
      
      // Turn off hover state when using arrows
      card.setAttribute('data-hover-active', 'false');
      
      // Make images visible as needed
      images.forEach((img, idx) => {
        if (idx === currentIndex) {
          img.style.display = 'block';
          img.style.opacity = '1';
          img.style.visibility = 'visible';
          img.style.transition = 'opacity 0.3s ease';
        } else {
          img.style.opacity = '0';
          img.style.display = 'block';
          // Keep non-current images ready but hidden
          img.style.visibility = idx === 0 || idx === 1 ? 'visible' : 'hidden';
        }
      });
      
      // Update card attribute
      card.setAttribute('data-carousel-current', currentIndex.toString());
    });
  });
  
  // Also update left arrow to skip index 1
  document.querySelectorAll('.card__arrow--left').forEach(leftArrow => {
    // Check if we've already modified this arrow
    if (leftArrow.hasAttribute('data-hover-modified')) return;
    
    // Mark as modified
    leftArrow.setAttribute('data-hover-modified', 'true');
    
    // Remove any existing listeners
    const clone = leftArrow.cloneNode(true);
    leftArrow.parentNode.replaceChild(clone, leftArrow);
    
    // Add our custom handler
    clone.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const card = this.closest('.product-card-wrapper');
      if (!card) return;
      
      const mediaContainer = card.querySelector('.card__media .media');
      if (!mediaContainer) return;
      
      const images = Array.from(mediaContainer.querySelectorAll('img'));
      if (images.length <= 2) return; // Need at least 3 images for this to work
      
      // Get current index
      let currentIndex = card.hasAttribute('data-carousel-current') 
        ? parseInt(card.getAttribute('data-carousel-current'), 10)
        : 0;
      
      // Calculate previous index, but skip index 1 (reserved for hover)
      currentIndex = (currentIndex - 1 + images.length) % images.length;
      if (currentIndex === 1) {
        currentIndex = (currentIndex - 1 + images.length) % images.length;
      }
      
      // Lazy load the next image we're moving to
      lazyLoadCardImage(card, currentIndex);
      
      // Turn off hover state when using arrows
      card.setAttribute('data-hover-active', 'false');
      
      // Make images visible as needed
      images.forEach((img, idx) => {
        if (idx === currentIndex) {
          img.style.display = 'block';
          img.style.opacity = '1';
          img.style.visibility = 'visible';
          img.style.transition = 'opacity 0.3s ease';
        } else {
          img.style.opacity = '0';
          img.style.display = 'block';
          // Keep non-current images ready but hidden
          img.style.visibility = idx === 0 || idx === 1 ? 'visible' : 'hidden';
        }
      });
      
      // Update card attribute
      card.setAttribute('data-carousel-current', currentIndex.toString());
    });
  });
}

function initCardProductHover() {
  // For each product card
  document.querySelectorAll('.product-card-wrapper').forEach(function (card) {
    const mediaContainer = card.querySelector('.card__media .media');
    if (!mediaContainer) return;

    // Gather all images in the card's media
    const images = Array.from(mediaContainer.querySelectorAll('img'));
    if (images.length <= 1) return; // Need at least 2 images for hover effect

    // The content area where we want to detect hover
    const contentArea = card.querySelector('.card__content');
    if (!contentArea) return;
    
    // Remove any previous hover listeners to prevent duplicates
    const oldInstance = card.getAttribute('data-hover-initialized');
    if (oldInstance === 'true') return;
    
    // Mark this card as initialized
    card.setAttribute('data-hover-initialized', 'true');

    // Ensure the first image is loaded and visible, hide others until needed
    images.forEach((img, idx) => {
      if (idx === 0) {
        // Make sure first image is loaded
        lazyLoadCardImage(card, 0);
        img.style.display = 'block';
        img.style.opacity = '1';
        img.style.visibility = 'visible';
      } else {
        img.style.opacity = '0';
        img.style.display = 'none';
        img.style.visibility = 'hidden';
      }
      
      // Set up transition for smooth effects
      img.style.transition = 'opacity 0.3s ease';
    });

    // Track hover state to prevent conflicts
    let isHovering = false;

    // Remove any existing event listeners
    const newContentArea = contentArea.cloneNode(true);
    contentArea.parentNode.replaceChild(newContentArea, contentArea);
    
    // We'll apply mouseover/mouseout events to the content area
    newContentArea.addEventListener('mouseover', function() {
      // Don't proceed if we're already hovering
      if (isHovering) return;
      
      // Load the second image if not already loaded
      lazyLoadCardImage(card, 1);
      
      // Get current carousel index
      const currentIndex = card.hasAttribute('data-carousel-current') 
        ? parseInt(card.getAttribute('data-carousel-current'), 10)
        : 0;
      
      // Save the previous index before hover
      card.setAttribute('data-pre-hover-index', currentIndex);
      
      isHovering = true;
      card.setAttribute('data-hover-active', 'true');
      
      // Only switch to hover image if we're on the first image or a carousel image (not 2nd)
      if (currentIndex !== 1) { // Don't change if already on 2nd image (unlikely)
        // Make sure all images are properly positioned
        images.forEach((img, idx) => {
          if (idx === 1) { // Show second image for hover
            img.style.display = 'block';
            img.style.opacity = '1';
            img.style.visibility = 'visible';
          } else {
            img.style.opacity = '0';
            img.style.display = 'block';
            // Only first image should be visible when not active
            img.style.visibility = idx === 0 ? 'visible' : 'hidden';
          }
        });
      }
    });

    newContentArea.addEventListener('mouseout', function() {
      // Don't proceed if we're not hovering
      if (!isHovering) return;
      
      isHovering = false;
      card.setAttribute('data-hover-active', 'false');
      
      // Get the index from before hover started
      const preHoverIndex = card.hasAttribute('data-pre-hover-index') 
        ? parseInt(card.getAttribute('data-pre-hover-index'), 10)
        : 0;
      
      // Restore to the previous image before hover
      images.forEach((img, idx) => {
        if (idx === preHoverIndex) { // Show the pre-hover image
          img.style.display = 'block';
          img.style.opacity = '1';
          img.style.visibility = 'visible';
        } else {
          img.style.opacity = '0';
          img.style.display = idx <= 1 ? 'block' : 'none';
          img.style.visibility = idx === 0 ? 'visible' : 'hidden';
        }
      });
      
      // Restore the carousel index
      card.setAttribute('data-carousel-current', preHoverIndex.toString());
    });
  });
} 